module.exports = "<% if (pager.length > 0 ) { %> <li><a class=\"<%= hasPrev ? 'forcia-page' : 'forcia-css-disabled'%>\" data-offset=-1>&lt;</a></li> <% } %> <% pager.forEach(function(page) { %> <li <% if(page.isCurrent) { %> class=act <% }else{ %> class=forcia-page data-offset=\"<%= page.offset %>\" <% } %> ><a><%= page.num %></a> </li> <% }); %> <% if (pager.length > 0 ) { %> <li><a class=\"<%= hasNext ? 'forcia-page' : 'forcia-css-disabled'%>\" data-offset=1>&gt;</a></li> <% } %> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/pager-top.template.html
// module id = 51
// module chunks = 2